/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgList = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 16v6H2v-6zm14 2v2H10v-2zM6 18H4v2h2zm2-9v6H2V9zm14 2v2H10v-2zM6 11H4v2h2zm2-9v6H2V2zm14 2v2H10V4zM6 4H4v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgList as List };
